import { ApiError, get, post } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { AuthUser } from '@uncain/shared';

export function useCurrentUser() {
	return useQuery<AuthUser | null>({
		queryKey: queryKeys.auth.me,
		queryFn: async () => {
			try {
				return await get<AuthUser>('/auth/me');
			} catch (err) {
				// 401/403 means not authenticated — return null, don't throw
				if (err instanceof ApiError && (err.status === 401 || err.status === 403)) {
					return null;
				}
				throw err;
			}
		},
		retry: false,
		staleTime: 5 * 60 * 1000,
	});
}

export function useLogout() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: () => post<void>('/auth/logout'),
		onSuccess: () => {
			queryClient.setQueryData(queryKeys.auth.me, null);
			window.location.href = '/login';
		},
	});
}

export function useSwitchOrg() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (orgId: string) => post<void>('/auth/switch-org', { orgId }),
		onSuccess: () => {
			queryClient.invalidateQueries();
		},
	});
}
